import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Logo } from '@/components/Logo';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <header className="border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" data-testid="privacy-home-link"><Logo size="sm" /></Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 transition-colors"
            data-testid="privacy-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-sm bg-[#0047AB]/10 flex items-center justify-center">
            <Shield className="w-5 h-5 text-[#0047AB]" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-slate-900 tracking-tight">Privacy Policy</h1>
        </div>
        <p className="text-sm text-slate-500 mb-10">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <div className="prose prose-slate max-w-none text-sm leading-relaxed space-y-6">
          <section>
            <h2 className="font-heading text-lg font-semibold text-slate-900 mb-2">Information We Collect</h2>
            <p className="text-slate-700">
              We collect your name, email, phone number, company information, and any data you enter into
              the CRM (leads, notes, documents, appointments). We also collect usage data to improve the
              product.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-slate-900 mb-2">SMS / Mobile Information</h2>
            <p className="text-slate-700">
              <strong>
                No mobile information will be shared with third parties or affiliates for marketing or
                promotional purposes.
              </strong>{' '}
              All categories below exclude text messaging originator opt-in data and consent; this
              information will not be shared with any third parties. See our{' '}
              <Link to="/sms-terms" className="text-[#0047AB] underline">SMS Terms</Link> for full details.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-slate-900 mb-2">How We Use Your Data</h2>
            <p className="text-slate-700">
              To provide the CRM service, send you account notifications, deliver SMS/email reminders you
              opt into, process payments, prevent fraud, and improve our product.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-slate-900 mb-2">Sharing</h2>
            <p className="text-slate-700">
              We use vetted subprocessors (Twilio for SMS/voice, Stripe/PayPal for payments, Resend for
              email, MongoDB Atlas for storage). They process data only to deliver our service. We do not
              sell your data.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-slate-900 mb-2">Your Rights</h2>
            <p className="text-slate-700">
              You can access, correct, export, or delete your data at any time from Settings or by emailing{' '}
              <a href="mailto:support@realleadscrm.com" className="text-[#0047AB] underline">
                support@realleadscrm.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-slate-900 mb-2">Contact</h2>
            <p className="text-slate-700">
              Encore Business Services Group LLC &middot;{' '}
              <a href="mailto:support@realleadscrm.com" className="text-[#0047AB] underline">
                support@realleadscrm.com
              </a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
